import React from "react";

export const TABLE_COLUMN_MAIN_PAGE = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "nomorFJ",
        label: "Nomor FJ",
        options: {
            sort: false,
        },
    },
    {
        name: "fjDate",
        label: "Tanggal FJ",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeCabang",
        label: "Kode Cabang",
        options: {
            sort: false,
        },
    },
    {
        name: "dataOrder",
        label: "Nama Pembeli",
        options: {
            customBodyRender: (val) => <>{val?.name}</>,
            sort: false,
        },
    },
    {
        name: "dataOwner",
        label: "Nama STNK",
        options: {
            customBodyRender: (val) => <>{val?.name}</>,
            sort: false,
        },
    },
    {
        name: "dataVariant",
        label: "Kode Varian",
        options: {
            customBodyRender: (val) => <>{val?.kodeVariant}</>,
            sort: false,
        },
    },
    {
        name: "dataVariant",
        label: "Nama Varian",
        options: {
            customBodyRender: (val) => <>{val?.namaVariant}</>,
            sort: false,
        },
    },
    {
        name: "dataWarna",
        label: "Kode Warna",
        options: {
            customBodyRender: (val) => <>{val?.kodeWarna}</>,
            sort: false,
        },
    },
    {
        name: "dataWarna",
        label: "Nama Warna",
        options: {
            customBodyRender: (val) => <>{val?.namaWarnaKomersil}</>,
            sort: false,
        },
    },
    {
        name: "dataSeller",
        label: "Penjual",
        options: {
            customBodyRender: (val) => <>{val?.name}</>,
            sort: false,
        },
    },
    {
        name: "dataTypeSeller",
        label: "Jenis Penjual",
        options: {
            customBodyRender: (val) => <>{val?.value}</>,
            sort: false,
        },
    },
    {
        name: "salesOrderState",
        label: "Status",
        options: {
            customBodyRender: (val) => val?.replace(/_/g, " "),
            sort: false,
        },
    },
]

const searchOptions = [
    {
        label: "Pembeli",
        value: "orderName",
    },
    {
        label: "STNK",
        value: "ownerName",
    },
];

const statusOptions = [
    {
        label: "FJ DRAFT",
        value: "FJ_DRAFT",
    },
    {
        label: "FJ WAITING VIOLATION APPROVAL",
        value: "FJ_WAITING_VIOLATION_APPROVAL",
    },
    {
        label: "FJ APPROVED",
        value: "FJ_APPROVED",
    },
    {
        label: "FJ WAITING LEASING APPROVAL",
        value: "FJ_WAITING_LEASING_APPROVAL",
    },
    {
        label: "FJ LEASING APPROVED",
        value: "FJ_LEASING_APPROVED",
    },
    {
        label: "FJ SUBMITTED",
        value: "FJ_SUBMITTED",
    },
    {
        label: "FJ CANCEL APPROVED",
        value: "FJ_CANCEL_APPROVED",
    },
    {
        label: "FJ RETUR APPROVED",
        value: "FJ_RETUR_APPROVED",
    },
    {
        label: "FJ DELETED",
        value: "FJ_DELETED",
    },
];

export const config = {
    tableColumns: TABLE_COLUMN_MAIN_PAGE,
    searchOptions,
    statusOptions
}